/* eslint-disable max-lines-per-function */
import { createTranslatedText } from '@dreryk/react-common';
import { Heading, NotFoundPanel, Scroll } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { DocumentTemplateForm } from '~libs.desktop.shared.document-template';
import { visitPaths } from '~libs.desktop.shared.paths';

import { VisitDocumentApproveAndPrintAction } from './actions/VisitDocumentApproveAndPrintAction';
import { VisitDocumentApproveAndShareAction } from './actions/VisitDocumentApproveAndShareAction';
import { DocumentTemplateFormLoader } from './DocumentTemplateForm.loader';
import { DocumentTemplateFormLeavingGuard } from './DocumentTemplateFormLeavingGuard';
import { StyledDocumentTemplateForm } from './DocumentTemplatePanel.styled';
import { VisitDocumentsAddDiagnosesModalOpener } from './modals/diagnoses/VisitDocumentsDiagnosesModal.opener';

type DocumentTemplatePanelProps = {
   readonly patientId: number;
};

export const DocumentTemplatePanel = (props: DocumentTemplatePanelProps): JSX.Element => {
   const { printTemplateId, visitId } = visitPaths.useDocumentTemplateParams();

   if (!printTemplateId) {
      return <NotFoundPanel />;
   }

   return (
      <Scroll testId={'documentTemplate'}>
         <DocumentTemplateFormLoader visitId={visitId} printTemplateId={printTemplateId}>
            {({ documentTemplate, documentTemplateDraft }) => (
               <StyledDocumentTemplateForm direction={'column'} gap={7} flex={'1'}>
                  <Heading testId={'name'} type='h1' margin={0} content={createTranslatedText(documentTemplate.name)} />
                  <VisitDocumentsAddDiagnosesModalOpener>
                     {({ tagActions }) => (
                        <DocumentTemplateForm
                           documentTemplate={documentTemplate}
                           documentTemplateDraft={documentTemplateDraft}
                           tagActions={tagActions}
                        >
                           {({ handleSubmit, handleSubmitDraft, formState, getValue, trigger, markPristine }) => (
                              <>
                                 <DocumentTemplateFormLeavingGuard
                                    handleSubmitDraft={handleSubmitDraft}
                                    visitId={visitId}
                                    printTemplateId={printTemplateId}
                                    formState={formState}
                                 />
                                 {protectFeature(
                                    'sendingDocumentsToPatient',
                                    <VisitDocumentApproveAndShareAction
                                       patientId={props.patientId}
                                       printTemplateId={printTemplateId}
                                       visitId={visitId}
                                       handleSubmit={handleSubmit}
                                       trigger={trigger}
                                       markPristine={markPristine}
                                       getValue={getValue}
                                    />,
                                    null
                                 )}
                                 <VisitDocumentApproveAndPrintAction
                                    patientId={props.patientId}
                                    visitId={visitId}
                                    printTemplateId={printTemplateId}
                                    handleSubmit={handleSubmit}
                                    markPristine={markPristine}
                                 />
                              </>
                           )}
                        </DocumentTemplateForm>
                     )}
                  </VisitDocumentsAddDiagnosesModalOpener>
               </StyledDocumentTemplateForm>
            )}
         </DocumentTemplateFormLoader>
      </Scroll>
   );
};
